<template>
  <div class="grid scroll-div">
    <div class="grid-title bg-primary">
      <h4 class="text-bold text-white">Next Delivery ( Placed order = yes )</h4>
      <FabricCalculationInfo>
        <template #title
          >This is a list of fabric that will be deliver soon</template
        >
        <template #content>
          <div class="calculation-info-container">
            <div class="title">ETA</div>
            <div class="description">
              ETA is the date when the fabric is expected to be fulfill by
              supplier.
            </div>
            <code>
              $supplierEfficiencyInDays = $supplierEfficiency * 7 <br />
              $result = formatDaysToDate($supplierEfficiencyInDays);
            </code>
          </div>

          <div class="calculation-info-container">
            <div class="title">Supplier</div>
            <div class="description">
              Supplier refers to the person who will supply the fabric for this
              order.
            </div>
          </div>
        </template>
      </FabricCalculationInfo>
    </div>
    <div class="grid-body p-0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th class="pointer" @click="sort('id')" width="150">
              Fabric
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="pointer" @click="sort('order_id')" width="150">
              Order
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="pointer" @click="sort('supplier')">
              Supplier
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-right pointer" @click="sort('amount')" width="100">
              Amount
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('eta')" width="150">
              ETA
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fabric, index) in fabrics" :key="index">
            <td>
              <router-link :to="'/fabric/update/' + fabric.id">
                {{ $Fabric.getCode(fabric.id) }} - {{ fabric.name }}
              </router-link>
            </td>
            <td>
              <router-link :to="'/fabric/order/update/' + fabric.order_id">
                {{ fabric.order_reference }}
              </router-link>
            </td>
            <td>{{ fabric.supplier }}</td>
            <td class="text-center">{{ ezy.comma(fabric.amount * 1) }} m</td>
            <td class="text-center">
              {{ moment(fabric.eta).format("DD MMM, YYYY") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import FabricCalculationInfo from "./FabricCalculationInfo";
export default {
  props: ["pageData"],
  components: { FabricCalculationInfo },
  data() {
    return {
      fabrics: [],
      sortType: "asc",
    };
  },
  methods: {
    sort(column) {
      this.sortType = this.sortType == "asc" ? "desc" : "asc";
      this.fabrics = _.orderBy(this.fabrics, [column], [this.sortType]);
    },
  },
  watch: {
    "pageData.fabricDeliveries": function () {
      let fabricDeliveries = this.pageData.fabricDeliveries;
      if (fabricDeliveries) {
        this.fabrics = fabricDeliveries;
        this.sort("eta");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;

  h4 {
    margin-top: 0;
  }
}
</style>

